// ============================================================
// main.js — Entry point
// ============================================================

// Estilos (inyectados por Webpack)
import '../scss/main.scss';

// Bootstrap 5 — bundle completo para que la data-API se auto-registre
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Módulos propios
import { initSidebar } from './sidebar.js';
import { initPromptBox, getPromptState } from './promptBox.js';
import { initGallery, createCardElement } from './gallery.js';
import { initCreationsModal } from './creationsModal.js';
import { initTemplatesPage } from './templatesPage.js';
import { initAvatarPage } from './avatarPage.js';
import { initHistorialPage } from './historialPage.js';
import { initCreacionesPage } from './creacionesPage.js';
import { initEscritorioPage } from './escritorioPage.js';
import { initGuiasPage } from './guiasPage.js';
import { initMarketingPage } from './marketingPage.js';
import { initAuthPage } from './authPage.js';
import { initPerfilPage } from './perfilPage.js';
import { initPagoPage } from './pagoPage.js';
import { initAdminPage } from './adminPage.js';
import { initI18n, applyCurrentTranslations } from './i18n.js';
import * as api from './api.js';
import { toast } from './toast.js';
import { showSubscriptionModal } from './subscriptionModal.js';

// API global para que el backend pueda interactuar desde plantillas
// (por ejemplo, inyectar datos desde el servidor con window.Vimo.setUser)
window.Vimo = {
  getPromptState,
  api,
  version: '1.0.0',
};

// Inicialización al cargar el DOM
document.addEventListener('DOMContentLoaded', () => {
  // 1. Inicializar sistema de traducción en todas las pantallas
  initI18n();

  const page = document.body.dataset.page;
  const protectedPages = ['escritorio', 'imagenes', 'video', 'avatar', 'plantillas', 'historial', 'perfil', 'pago', 'creaciones', 'admin-newsletter', 'admin-suscripciones', 'admin-cuotas'];
  const authPages = ['login', 'registro', 'recuperar'];
  
  const token = api.getAccessToken();
  
  if (protectedPages.includes(page) && !token) {
    window.location.href = 'login.html';
    return;
  }
  
  if (authPages.includes(page) && token) {
    window.location.href = 'escritorio.html';
    return;
  }

  // Si intenta acceder a páginas de admin pero no tiene el rol admin
  const user = api.getUser();
  const adminPages = ['admin-newsletter', 'admin-suscripciones', 'admin-cuotas'];
  if (adminPages.includes(page) && (!user || user.role !== 'admin')) {
    window.location.href = 'escritorio.html';
    return;
  }

  // Update Topbar user info dynamically
  if (user) {
    const topName = document.querySelector('.topbar-user-name');
    const topEmail = document.querySelector('.topbar-user-email');
    const topAvatar = document.querySelector('.topbar-user-avatar');
    
    if (topName) topName.textContent = user.name || user.email.split('@')[0];
    if (topEmail) topEmail.textContent = user.email;
    if (topAvatar) {
      const initial = (user.name || user.email).substring(0, 2).toUpperCase();
      topAvatar.textContent = initial;
    }

    // Actualizar botones de la barra pública (landing / precios / inicio)
    const mkCtaGroup = document.querySelector('.mk-cta-group');
    if (mkCtaGroup) {
      mkCtaGroup.innerHTML = `
        <a href="escritorio.html" class="mk-cta-btn mk-cta-btn-outline" style="text-decoration:none;" data-i18n="topbar_goto_dashboard">Ir al Escritorio</a>
        <button type="button" class="mk-link-soft" id="mkAuthLogoutBtn" style="background:none;border:none;cursor:pointer;color:inherit;font-weight:600;font-size:14px;" data-i18n="topbar_logout">Cerrar sesión</button>
      `;
      const logoutBtn = document.getElementById('mkAuthLogoutBtn');
      if (logoutBtn) {
        logoutBtn.addEventListener('click', () => {
          api.clearTokens();
          window.location.reload();
        });
      }
    }

    // Mostrar menús de administración si el usuario es administrador
    if (user.role === 'admin') {
      document.querySelectorAll('[data-admin-only]').forEach((el) => {
        el.style.display = '';
      });
      // Volver a aplicar traducciones para los elementos admin recién mostrados
      applyCurrentTranslations();
    }
  }

  initSidebar();
  initPromptBox();
  initGallery();
  initCreationsModal();
  initTemplatesPage();
  initAvatarPage();
  initHistorialPage();
  initCreacionesPage();
  initEscritorioPage();
  initGuiasPage();
  initMarketingPage();
  initAuthPage();
  initPerfilPage();
  initPagoPage();
  initAdminPage();

  // Dropdowns Bootstrap — instanciación explícita por si la data-API
  // no se registra a tiempo (necesario en algunos bundles).
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((el) => {
    bootstrap.Dropdown.getOrCreateInstance(el);
  });

  // Tooltips Bootstrap
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    bootstrap.Tooltip.getOrCreateInstance(el);
  });

  // Hook global de generación — crea dinámicamente nuevas tarjetas en la rejilla
  document.addEventListener('vimo:generate', async (e) => {
    const payload = e.detail;
    console.log('[Vimo] evento vimo:generate capturado por main.js', payload);

    const gridId = payload.type === 'video' ? '#videoGallery' : '#imageGallery';
    const grid = document.querySelector(gridId);

    // Si está el mensaje de rejilla vacía, eliminarlo
    if (grid) {
      const emptyState = grid.querySelector('.gallery-empty-state');
      if (emptyState) emptyState.remove();
    }

    // Evitar tarjetas de carga duplicadas
    const existingLoading = grid ? grid.querySelector('#loadingCardTemp') : null;
    if (existingLoading) existingLoading.remove();

    // Crear tarjeta de carga provisional
    const loadingCard = document.createElement('div');
    loadingCard.id = 'loadingCardTemp';
    loadingCard.className = `gen-card is-generating ${payload.type === 'video' ? 'is-video' : ''}`;
    loadingCard.innerHTML = `
      <div class="gen-card-placeholder" style="display: flex; flex-direction: column; align-items: center; justify-content: center; width:100%; height:100%; min-height: 220px; text-align: center; padding: 20px;">
        <div class="spinner-border text-light" role="status" style="width: 2.2rem; height: 2.2rem; border-width: 0.22em; margin-bottom: 14px;"></div>
        <span class="gen-loading-text" style="font-size: 0.88rem; opacity: 0.95; font-weight: 600; color: #fff;">${payload.type === 'video' ? 'Generando vídeo con IA...' : 'Generando imagen...'}</span>
        <span class="gen-loading-sub" style="font-size: 0.75rem; opacity: 0.65; margin-top: 5px; color: #cbd5e1;">${payload.type === 'video' ? 'Los modelos de vídeo en alta definición suelen tardar entre 2 y 3 minutos' : 'Procesando prompt'}</span>
      </div>
    `;

    if (grid) {
      grid.insertBefore(loadingCard, grid.firstChild);
    }

    try {
      let result;
      if (payload.type === 'video') {
        result = await api.generateVideo(payload);
      } else {
        result = await api.generateImage(payload);
      }
      console.log('[Vimo] respuesta API:', result);

      let finalUrl = result?.result?.url || result?.resultUrl;
      let finalId = result?.id || result?.jobId;

      if (!finalUrl && result?.jobId) {
        const textSpan = loadingCard.querySelector('.gen-loading-text');
        const subSpan = loadingCard.querySelector('.gen-loading-sub');
        if (textSpan) textSpan.textContent = 'En cola de procesamiento IA...';

        let attempts = 0;
        const maxAttempts = 120; // 5 minutos máximo
        while (attempts < maxAttempts) {
          await new Promise(r => setTimeout(r, 2500));
          attempts++;
          try {
            const jobData = await api.getJobStatus(result.jobId);
            if (jobData.status === 'processing') {
              if (textSpan) textSpan.textContent = 'Renderizando fotogramas del vídeo...';
              if (subSpan) subSpan.textContent = `Procesando IA (${Math.round(attempts * 2.5)}s transcurridos)`;
            }
            if (jobData.status === 'completed') {
              finalUrl = jobData.resultUrl || jobData.result?.url;
              finalId = jobData.jobId || result.jobId;
              break;
            }
            if (jobData.status === 'failed') {
              throw new Error(jobData.error || 'La generación del vídeo ha fallado.');
            }
          } catch (pollErr) {
            console.warn('[Vimo] Aviso sondeando job:', pollErr.message);
            if (pollErr.message && !pollErr.message.includes('HTTP') && !pollErr.message.includes('Failed to fetch')) {
              throw pollErr;
            }
          }
        }
      }

      if (finalUrl) {
        const newCard = createCardElement({ url: finalUrl, title: payload.prompt, id: finalId }, payload.type);
        if (loadingCard.parentNode) {
          loadingCard.parentNode.replaceChild(newCard, loadingCard);
        }
        toast({ message: payload.type === 'video' ? '🎬 ¡Vídeo generado con éxito!' : '✨ ¡Imagen generada con éxito!', type: 'success' });
      } else {
        if (loadingCard.parentNode) loadingCard.remove();
        toast({ message: 'No se pudo obtener el resultado de la generación', type: 'error' });
      }
    } catch (err) {
      console.error('[Vimo] error al generar:', err);
      if (loadingCard.parentNode) loadingCard.remove();

      // Si es un error de saldo/créditos de la API para administrador demo:
      const isCreditError = /ALERTA DE|CRÉDITOS|CUOTA|Insufficient credit|credit|400133|402|balance|quota|Modo Admin/i.test(err.message);
      if (isCreditError) {
        showAdminCreditModal({
          title: '⚠️ ALERTA DE CRÉDITOS / CUOTA IA',
          message: err.message.replace(/^Error [^:]+:\s*/i, ''),
          provider: err.message.includes('HeyGen') ? 'HeyGen' : 'Fal.ai',
        });
      } else if (err.message.includes('prueba gratuito') || err.message.includes('trial') || err.message.includes('suscripción') || err.message.includes('límite')) {
        showSubscriptionModal({
          title: '¡Activa tu Período de Prueba!',
          message: err.message.replace(/^Error al [^:]+:\s*/i, ''),
          redirectUrl: 'precios.html',
        });
      } else {
        toast({ message: `Error al generar: ${err.message}`, type: 'error' });
      }
    }
  });
});
